import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { syncPortalEmbedHeightReporting } from './core/utils/portal-embed-height';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  styleUrl: './app.css',
  standalone: true,
})
export class App implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  constructor() {
    syncPortalEmbedHeightReporting(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => syncPortalEmbedHeightReporting(event.urlAfterRedirects));
  }

  async ngOnInit() {
    // Check session on app start, but don't redirect if on public route
    // The auth service will handle redirects appropriately
    await this.authService.checkSession();
  }
}
